<template>
  <a-modal v-model="visible" title="" :closable="false" :footer="null" :mask-closable="false">
    <div class="okTips">
      <p class="title">
        <img src="@/assets/img/auth/icon_warning_circle_field.png" alt="">
        实名认证并签约后才能下单
      </p>
      <p class="tips_text">请先前往申请认证</p>
      <div class="btn">
        <a-button @click="handleCancel">
          取消
        </a-button>
        <a-button type="primary" @click="handleOk">
          前往认证
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>

export default {
  name: 'Auth',
  data(){
    return {
      visible: true
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    handleOk(){
      this.$emit('success')
    }
  }
}
</script>
<style lang="less" scoped>
img{
  width: 24px;
  height: 24px;
  vertical-align: top;
}
.title{
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.tips_text{
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  padding-left: 30px;
}
.btn{
  text-align: right;
  margin-top: 16px;
  button{
    margin-left: 8px;
  }
}
</style>
